import Service from './Service';

class PostService extends Service {
  /**
  * @type {string}
  */
  apiResource = "/posts";

  getComments(resource, config = null) {
    return this.get(`/${resource.id}/comments`, config);
  }

  comment(resource, data, config = null) {
    return this.post(`/${resource.id}/comments`, data, config);
  }

  report(resource, config = null) {
    return this.patch(`/${resource.id}/report`, config);
  }

  reportComment(post, resource, config = null) {
    return this.patch(`/${post.id}/comments/${resource.id}/report`, config);
  }
}

export default new PostService();
